export class GoogleMapsEmbedError extends Error {
  constructor(message = 'invalid_google_maps_embed') {
    super(message);
    this.name = 'GoogleMapsEmbedError';
  }
}

const ALLOWED_HOSTS = new Set(['google.com', 'www.google.com', 'maps.google.com']);

export const normalizeGoogleMapsEmbed = (raw: string): string => {
  const value = raw.trim();
  if (!value) {
    throw new GoogleMapsEmbedError('empty_google_maps_embed');
  }

  let source = value;
  const iframeMatch = value.match(/<iframe\b[^>]*\bsrc=(["'])(.*?)\1/i);
  if (iframeMatch?.[2]) {
    source = iframeMatch[2];
  }

  let parsed: URL;
  try {
    parsed = new URL(source);
  } catch {
    throw new GoogleMapsEmbedError();
  }

  if (!ALLOWED_HOSTS.has(parsed.hostname.toLowerCase()) || !/\/maps\/(?:d\/)?embed$/i.test(parsed.pathname)) {
    throw new GoogleMapsEmbedError();
  }

  const code = parsed.search.replace(/^\?/, '');
  if (!code || (!code.startsWith('pb=') && !code.startsWith('mid='))) {
    throw new GoogleMapsEmbedError();
  }
  return code;
};

export const buildGoogleMapsEmbedUrl = (code: string): string => {
  const normalized = code.trim();
  if (!normalized.startsWith('pb=') && !normalized.startsWith('mid=')) {
    throw new GoogleMapsEmbedError();
  }
  const path = normalized.startsWith('mid=') ? '/maps/d/embed' : '/maps/embed';
  return `https://www.google.com${path}?${normalized}`;
};
